import {
  nettoyageExpress,
  nettoyageApprofondi,
  nettoyageSupreme,
  polishCorrection,
  ceramiqueCarrosserie,
  cielEtoile,
} from '../../../mocks/prestations';

interface CategoryStepProps {
  data: any;
  updateData: (data: any) => void;
  nextStep: () => void;
  prevStep: () => void;
}

export default function CategoryStep({
  data,
  updateData,
  nextStep,
  prevStep,
}: CategoryStepProps) {
  const categories = [
    { id: 'express', name: 'Express', icon: 'ri-flashlight-line', prestations: nettoyageExpress },
    { id: 'approfondi', name: 'Approfondi', icon: 'ri-water-flash-line', prestations: nettoyageApprofondi },
    { id: 'supreme', name: 'Suprême', icon: 'ri-vip-crown-line', prestations: nettoyageSupreme },
    { id: 'polish', name: 'Polish & Correction', icon: 'ri-contrast-drop-line', prestations: polishCorrection },
    { id: 'ceramique', name: 'Céramique', icon: 'ri-shield-star-line', prestations: ceramiqueCarrosserie },
    { id: 'ciel', name: 'Ciel Étoilé', icon: 'ri-sparkling-line', prestations: cielEtoile },
  ];

  const handleSelect = (categoryId: string) => {
    try {
      updateData({ category: categoryId });
      nextStep();
    } catch (error) {
      console.error('Error handling category selection:', error);
    }
  };

  return (
    <div className="bg-dark-card border border-dark-border rounded-2xl p-4 sm:p-6 lg:p-8">
      <div className="text-center mb-6 sm:mb-8">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">Choisissez une catégorie</h2>
        <p className="text-gray-400 text-sm sm:text-base">Sélectionnez le type de service</p>
      </div>

      <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => handleSelect(cat.id)}
            className="p-4 sm:p-6 rounded-xl border-2 border-dark-border hover:border-primary/50 transition-all duration-300 hover:scale-105 cursor-pointer min-h-[120px] sm:min-h-[140px] flex flex-col items-center justify-center touch-manipulation active:scale-95"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-primary/20 rounded-full mb-3">
                <i className={`${cat.icon} text-2xl sm:text-3xl text-primary`}></i>
              </div>
              <h3 className="text-white font-semibold text-sm sm:text-base">{cat.name}</h3>
            </div>
          </button>
        ))}
      </div>

      <button
        onClick={prevStep}
        className="w-full py-3 sm:py-4 border-2 border-dark-border text-white rounded-lg hover:border-primary/50 transition-all duration-300 whitespace-nowrap min-h-[44px] touch-manipulation text-sm sm:text-base"
      >
        ← Retour
      </button>
    </div>
  );
}
